import {
	useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useMemo} from "react";
import {IWayPointCreationMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/types";
import {
	useGetPointTemplateByIdsSingleVoyages
} from "@containers/singleVoyage/pointTemplates/hooks/useGetPointTemplateByIdsSingleVoyages";

export function useGetWayPointsMutateSingleVoyage(): IWayPointCreationMutateSingleVoyage[] {
	const {
		points,
		tasks,
		accountId,
	} = useRootContextMutateSingleVoyage()
	
	const templatePointIds = useMemo(() => {
		if (!points?.length) {
			return []
		}
		return points.filter((point) => !!point.waypointTemplateId)
			.map((point) => point.waypointTemplateId)
	}, [points])
	const {
		getPointTemplateById
	} = useGetPointTemplateByIdsSingleVoyages({
		accountId: Number(accountId),
		ids: templatePointIds
	})
	
	return useMemo(() => {
		return points.map((point) => {
			const currentTasks = tasks?.filter((task) => {
				if (task?.waypointIds?.includes(Number(point?.id))) {
					return true
				}
				return task.subtasks.some((subTask) => subTask?.waypointIds?.includes(Number(point?.id)))
			})
			return {
				...point,
				// Do not cut the task down: narrowing to a stop is the view's job
				// (narrowToWaypoint), otherwise the right panel hides the other stops.
				tasks: currentTasks,
				waypointTemplate: point.waypointTemplateId ? getPointTemplateById(point.waypointTemplateId) : null
			}
		})
	}, [points, tasks, getPointTemplateById])
}
